module.exports = __webpack_public_path__ + "img/other@2x.3cf677dc.png";